module.exports = __webpack_public_path__ + "img/gb856.prt.1364d407.jpg";